import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/forgot-password/forget-password-client.tsx");
